// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"453":"operations","595":"materials","691":"colors","809":"users","852":"orders","964":"product","966":"login"}[chunkId] + "." + {"453":"b09aba26","595":"d0b642a7","691":"6ea890ef","809":"1d30e12d","852":"c7cfda63","964":"d1a27615","966":"80156304"}[chunkId] + ".js";
};